'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('user-insights-overview', {
      url: '/admin/user-insights',
      template: '<user-insights></user-insights>',
      authenticate: 'superadmin'
    })
    .state('user-insights', {
      url: '/admin/user-insights/:id',
      template: '<user-insights></user-insights>',
      authenticate: 'superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/app/superadmin/user-insights/user-insights.routes.js